import { useState } from "react";
import { Buton, cn, MetinAlani } from "@koclukpanel/ui";
import type { Gorev } from "./api";

/**
 * "YAPAMADIM" NEDENI — F-STV-03
 *
 * ================================================================
 * BU VERI KOCA TESHIS SAGLIYOR
 * ================================================================
 * Sartname: "Uc hafta ust uste 'program cok yogundu' seciliyorsa sorun
 * ogrencide degil PLANLAMADADIR."
 *
 * Bu yuzden nedenler bir "mazeret listesi" gibi degil, notr biçimde
 * yazildi. "Zamanim yetmedi" ile "usendim" ayni cumleyle sorulsaydi
 * ogrenci en az sucluyu secer ve veri ise yaramazdi.
 *
 * Nedenler sunucudaki `MissReason` enum'uyla BIREBIR — arayuzde
 * fazladan bir secenek olsaydi sunucu reddederdi.
 */
export const NEDENLER = [
  { kod: "NO_TIME", etiket: "Zamanım yetmedi" },
  { kod: "DID_NOT_UNDERSTAND", etiket: "Konuyu anlamadım" },
  { kod: "NO_RESOURCE", etiket: "Kaynağa ulaşamadım" },
  { kod: "ILLNESS", etiket: "Hastalık / mazeret" },
  { kod: "TOO_INTENSE", etiket: "Program çok yoğundu" },
  { kod: "FORGOT", etiket: "Unuttum" },
  { kod: "OTHER", etiket: "Diğer" },
] as const;

interface YapamadimProps {
  gorev: Gorev;
  onKapat: () => void;
  onGonder: (neden: string, not: string | null) => void;
}

export function Yapamadim({ gorev, onKapat, onGonder }: YapamadimProps) {
  const [neden, setNeden] = useState<string | null>(null);
  const [not, setNot] = useState("");

  // "Diger" secildiginde metin ZORUNLU — sunucu da bunu dayatiyor.
  // Zorunlu olmasaydi herkes "diger"i secip gecer ve veri kaybolurdu.
  const notGerekli = neden === "OTHER";
  const gonderilebilir = neden !== null && (!notGerekli || not.trim().length >= 3);

  return (
    <div className="bg-notr-0 fixed inset-0 z-50 flex flex-col">
      <header className="border-notr-200 flex items-center justify-between border-b px-4 py-3">
        <div className="min-w-0">
          <h2 className="truncate text-base font-semibold">Yapamadım</h2>
          <p className="text-notr-600 truncate text-sm">
            {gorev.lesson.name}
            {gorev.topic && ` · ${gorev.topic.name}`}
          </p>
        </div>
        <Buton gorunum="sessiz" onClick={onKapat}>
          Kapat
        </Buton>
      </header>

      <div className="flex-1 overflow-y-auto p-4">
        <p className="text-notr-600 mb-4 text-sm">
          Nedenini seç. Bu bilgi koçunun programı sana göre düzeltmesi için gerekli — not olarak
          tutulmuyor.
        </p>

        <div className="flex flex-col gap-2" role="radiogroup" aria-label="Yapamama nedeni">
          {NEDENLER.map((n) => (
            <button
              key={n.kod}
              type="button"
              role="radio"
              aria-checked={neden === n.kod}
              onClick={() => setNeden(n.kod)}
              className={cn(
                "min-h-dokunma rounded-alan flex items-center gap-3 px-4 text-left text-base",
                neden === n.kod
                  ? "bg-marka-50 text-marka-700 ring-marka-600 font-medium ring-2 ring-inset"
                  : "bg-notr-50 text-notr-800 hover:bg-notr-100",
              )}
            >
              <span
                aria-hidden="true"
                className={cn(
                  "flex size-5 shrink-0 items-center justify-center rounded-full text-xs",
                  neden === n.kod ? "bg-marka-600 text-notr-0" : "ring-notr-300 ring-1",
                )}
              >
                {neden === n.kod ? "✓" : ""}
              </span>
              {n.etiket}
            </button>
          ))}
        </div>

        {neden && (
          <div className="mt-5">
            <MetinAlani
              etiket={notGerekli ? "Kısaca anlat (zorunlu)" : "Eklemek istediğin bir şey var mı?"}
              value={not}
              onChange={(e) => setNot(e.target.value)}
              rows={3}
              autoFocus={notGerekli}
            />
          </div>
        )}
      </div>

      <footer className="border-notr-200 border-t p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
        <Buton
          boyut="genis"
          disabled={!gonderilebilir}
          onClick={() => onGonder(neden!, not.trim() || null)}
        >
          Gönder
        </Buton>
      </footer>
    </div>
  );
}
